import { USER_WORKER_URL } from '../../../config.js';
import { fetchCache } from '../../../utils/fetchCache.js';
import { getSession } from '../../../utils/auth_utils.js';

export const SPRITE_DOWNVOTE_REASONS = Object.freeze([
  'bad_background_removal',
  'poor_quality',
  'doesnt_match_action',
  'doesnt_match_outfit',
  'changed_appearance',
  'changed_outfit',
  'other'
]);

const parseRpcPayload = (data) => {
  if (data && typeof data === 'object') return data;
  return { success: false };
};

const postAuthenticatedJson = async (path, body) => {
  const session = await getSession();
  if (!session?.access_token) {
    return { success: false, error: 'Not authenticated', error_code: 'AUTH_REQUIRED' };
  }

  try {
    const data = await fetchCache.fetchJSON(`${USER_WORKER_URL.replace(/\/+$/, '')}${path}`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${session.access_token}`
      },
      body: JSON.stringify(body)
    });
    return parseRpcPayload(data);
  } catch (error) {
    console.warn('[spriteVoteService] Request failed:', error);
    return { success: false, error: error?.message || 'Request failed' };
  }
};

/**
 * Persist an image or video sprite vote. One row per user+sprite; later votes update.
 * @param {{ isVideo: boolean, characterId: string|number, outfitId: string|number, actionId: string|number, videoActionId?: string|number|null, vote: 1|-1, reason?: string|null }} params
 */
export const persistSpriteVote = async ({
  isVideo,
  characterId,
  outfitId,
  actionId,
  videoActionId = null,
  vote,
  reason = null
}) => {
  const character_id = Number(characterId);
  const outfit_id = Number(outfitId);
  const action_id = Number(actionId);
  if (!Number.isInteger(character_id) || !Number.isInteger(outfit_id) || !Number.isInteger(action_id)) {
    return { success: false, error: 'Missing sprite identifiers' };
  }
  if (vote !== 1 && vote !== -1) {
    return { success: false, error: 'Invalid vote' };
  }
  if (vote === -1 && !SPRITE_DOWNVOTE_REASONS.includes(reason)) {
    return { success: false, error: 'Invalid downvote reason' };
  }

  if (isVideo) {
    const video_action_id = Number(videoActionId);
    if (!Number.isInteger(video_action_id)) {
      return { success: false, error: 'Missing video_action_id' };
    }
    return postAuthenticatedJson('/sprite-video-vote', {
      character_id,
      outfit_id,
      action_id,
      video_action_id,
      vote,
      reason: vote === -1 ? reason : null
    });
  }

  return postAuthenticatedJson('/sprite-vote', {
    character_id,
    outfit_id,
    action_id,
    vote,
    reason: vote === -1 ? reason : null
  });
};
